module.exports = __webpack_public_path__ + "static/media/kids.db5d5a3e.jpg";